import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import NewMemberRegistration from "./pages/NewMemberRegistration";
import Dashboard from "./pages/Dashboard";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import History from "./pages/History";
import Profile from "./pages/Profile";
import Team from "./pages/Team";
import CopyTrade from "./pages/CopyTrade";
import CommunitySupport from "./pages/CommunitySupport";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDeposits from "./pages/AdminDeposits";
import AdminWithdrawals from "./pages/AdminWithdrawals";
import AdminKyc from "./pages/AdminKyc";
import AdminCommunity from "./pages/AdminCommunity";
import AdminHiddenAccounts from "./pages/AdminHiddenAccounts";
import RouteErrorBoundary from "./components/RouteErrorBoundary";

const isAuthenticated = () => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("naxoraToken");
  return !!token;
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />

      <Route path="/join" element={<NewMemberRegistration />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/deposit"
        element={
          <ProtectedRoute>
            <Deposit />
          </ProtectedRoute>
        }
      />

      <Route
        path="/withdraw"
        element={
          <ProtectedRoute>
            <Withdraw />
          </ProtectedRoute>
        }
      />

      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/team"
        element={
          <ProtectedRoute>
            <Team />
          </ProtectedRoute>
        }
      />

      <Route
        path="/copytrade"
        element={
          <ProtectedRoute>
            <CopyTrade />
          </ProtectedRoute>
        }
      />

      <Route
        path="/community"
        element={
          <ProtectedRoute>
            <CommunitySupport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/hidden-accounts"
        element={
          <ProtectedRoute>
            <RouteErrorBoundary>
              <AdminHiddenAccounts />
            </RouteErrorBoundary>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/deposits"
        element={
          <ProtectedRoute>
            <RouteErrorBoundary>
              <AdminDeposits />
            </RouteErrorBoundary>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/withdrawals"
        element={
          <ProtectedRoute>
            <RouteErrorBoundary>
              <AdminWithdrawals />
            </RouteErrorBoundary>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/kyc"
        element={
          <ProtectedRoute>
            <AdminKyc />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/community"
        element={
          <ProtectedRoute>
            <RouteErrorBoundary>
              <AdminCommunity />
            </RouteErrorBoundary>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;